/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Packs_DescriptionInputs */

const en_directory_ai_tools_packs_description = /** @type {(inputs: Directory_Ai_Tools_Packs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No subscription. Pack credits never expire, and a failed render never costs you anything.`)
};

const zh_directory_ai_tools_packs_description = /** @type {(inputs: Directory_Ai_Tools_Packs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无需订阅。积分包永不过期，生成失败不扣任何费用。`)
};

/**
* | output |
* | --- |
* | "No subscription. Pack credits never expire, and a failed render never costs you anything." |
*
* @param {Directory_Ai_Tools_Packs_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_packs_description = /** @type {((inputs?: Directory_Ai_Tools_Packs_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Packs_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_packs_description(inputs)
	return zh_directory_ai_tools_packs_description(inputs)
});
export { directory_ai_tools_packs_description as "directory.ai_tools.packs.description" }